import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { LayoutLibrary } from '../..'
import { SizeTracker } from '../../../common/SizeTracker'
import FilterCompanyDisplay from '../../../common/filterCompany/filterDisplay'
import {
  selectLoadingDefault,
  selectParamsSetting,
} from '../../../common/filterCompany/store/slice'
import { Loading } from '../../../common/loading'
import { Table } from '../../../common/table'
import { ROUTE_LIBRARY, TYPE_SORT_FOLLOWING_LIST } from '../../constant'

import { PaginationTableFilterCompanies } from './components/Pagination'
import { Header } from './headerFilteredCompany'
import { Title } from './headerFilteredCompany/Title'
import classes from './index.module.scss'
import { getSchemaTableFilteredCompany } from './schemaTableFilteredCompany'
import {
  changeFilter,
  getOpenFilter,
  resetStore,
  selectDataCheckBox,
  selectDataTable,
  selectFilterTableFilterCompany,
  selectIds,
  selectLoading,
} from './store/slice'
import {
  getAllIdCompanyFilter,
  getFilteredCompanies,
  getScoreRangesCreditRisk,
  getScoreRangesPerformance,
} from './store/thunk'

const FilteredCompanies = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const ids = useSelector(selectIds)
  const listIdsSelected = useSelector(selectDataCheckBox('listIdsSelected'))
  const filter = useSelector(selectFilterTableFilterCompany())
  const locale = useSelector((state) => state.i18n.locale)
  const settingParams = useSelector(selectParamsSetting)
  const isOpen = useSelector(getOpenFilter)
  //loading
  const isLoading = useSelector(selectLoading('getFilteredCompanies'))
  const isLoadingGetAllId = useSelector(selectLoading('getAllIdOrg'))
  const isLoadingDefault = useSelector(selectLoadingDefault)

  //Actions
  const handleChangeSort = (sort) => {
    dispatch(
      changeFilter({
        sort: sort?.sortBy,
        sortDirection: sort?.sortDirection,
        page: 1,
        ...settingParams,
      }),
    )
  }

  const onClickFilter = () => {
    navigate(ROUTE_LIBRARY.FILTERED_COMPANIES_SETTING)
  }

  useEffect(() => {
    if (Object.keys(settingParams).length !== 0) {
      dispatch(
        getFilteredCompanies({
          ...filter,
          sort: TYPE_SORT_FOLLOWING_LIST.DELIVERY_DATE_ID,
          ...settingParams,
        }),
      )
    }
  }, [JSON.stringify(filter), JSON.stringify(settingParams), locale])

  useEffect(() => {
    if (Object.keys(settingParams).length !== 0) {
      dispatch(
        getAllIdCompanyFilter({
          term: filter?.term,
          ...settingParams,
        }),
      )
    }
  }, [filter?.term, JSON.stringify(settingParams)])

  useEffect(() => {
    dispatch(getScoreRangesCreditRisk())
    dispatch(getScoreRangesPerformance())
  }, [locale])

  useEffect(() => {
    return () => {
      dispatch(resetStore())
    }
  }, [])

  return (
    <LayoutLibrary
      renderTopComponent={() => (
        <div style={{ margin: '0 6px' }}>
          <Title />
          <FilterCompanyDisplay onClickFilter={onClickFilter} />
        </div>
      )}
      renderBottomComponent={() => {
        return (
          <div className={classes.filteredCompany} style={{ padding: '0 6px' }}>
            <SizeTracker
              renderTopComponent={() => (
                <Header listIdsSelected={listIdsSelected} />
              )}
            >
              {(size) => {
                return (
                  <div style={{ height: `calc(100% - ${size.height}px)` }}>
                    {isLoadingGetAllId || isLoadingDefault || isLoading ? (
                      <Loading />
                    ) : (
                      <>
                        <Table
                          keyReCalculateSize={size.height + Number(isOpen)}
                          ids={ids}
                          getDataFromRedux={selectDataTable}
                          isLoading={isLoading}
                          noDataText={
                            !!filter?.term
                              ? 'library.main.NOTI_NO_COMPANY_SEARCH'
                              : 'library.filterCompanies.NO_DATA'
                          }
                          isNoDataWithHead={true}
                          schema={getSchemaTableFilteredCompany()}
                          sort={{
                            sortBy: filter?.sort,
                            sortDirection: filter?.sortDirection,
                          }}
                          changeSort={handleChangeSort}
                          renderPagination={PaginationTableFilterCompanies}
                          isCenterNoData={false}
                        />
                      </>
                    )}
                  </div>
                )
              }}
            </SizeTracker>
          </div>
        )
      }}
    />
  )
}

export default FilteredCompanies
